<app-display-card>
  <div
    class="row justify-content-between align-items-center"
    (click)="collapse = !collapse"
  >
    <div class="col-4">
      <h3>Trade Specific Compliance Tiers</h3>
    </div>

    <div class="col-3 text-end">
      <i
        class="bi bi-chevron-{{ collapse ? 'up' : 'down' }} fs-32 fw-semibold"
      ></i>
    </div>
  </div>

  @if (complianceSettingForms) {
    <div class="inner-panel rounded" [(ngbCollapse)]="collapse">
      @if (!collapse) {
        <div class="row mx-2">
          <div class="col">
            @for (
              trade of tradeRiskLevelMap | keyvalue: keyValuePairDefaultOrder;
              track trade
            ) {
              <div class="row py-2">
                <div class="col-3">
                  <label class="form-label">{{ trade.key }}</label>
                </div>
                <div class="col-3">
                  <div class="form-check-group mt-0">
                    <input
                      id="complianceSettingTierRiskLevel1_{{ trade.key }}_{{
                        trade.value.riskLevel1.complianceSettingId
                      }}"
                      type="radio"
                      class="form-check-input"
                      (click)="
                        onRiskLevelClick(
                          trade.value.riskLevel1.complianceSettingId,
                          trade
                        )
                      "
                      [checked]="trade.value.riskLevel1.checked"
                    />
                    <label
                      for="complianceSettingTierRiskLevel1_{{ trade.key }}_{{
                        trade.value.riskLevel1.complianceSettingId
                      }}"
                      class="form-check-label"
                      >Risk Level 1</label
                    >
                  </div>
                </div>
                @if (enableRiskLevel2) {
                  <div class="col-3">
                    <div class="form-check-group mt-0">
                      <input
                        id="complianceSettingTierRiskLevel2_{{ trade.key }}_{{
                          trade.value.riskLevel2.complianceSettingId
                        }}"
                        type="radio"
                        class="form-check-input"
                        (click)="
                          onRiskLevelClick(
                            trade.value.riskLevel2.complianceSettingId,
                            trade
                          )
                        "
                        [checked]="trade.value.riskLevel2.checked"
                      />
                      <label
                        for="complianceSettingTierRiskLevel2_{{ trade.key }}_{{
                          trade.value.riskLevel2.complianceSettingId
                        }}"
                        class="form-check-label"
                        >Risk Level 2</label
                      >
                    </div>
                  </div>
                }
                @if (enableRiskLevel3) {
                  <div class="col-3">
                    <div class="form-check-group mt-0">
                      <input
                        id="complianceSettingTierRiskLevel3_{{ trade.key }}_{{
                          trade.value.riskLevel3.complianceSettingId
                        }}"
                        type="radio"
                        class="form-check-input"
                        (click)="
                          onRiskLevelClick(
                            trade.value.riskLevel3.complianceSettingId,
                            trade
                          )
                        "
                        [checked]="trade.value.riskLevel3.checked"
                      />
                      <label
                        for="complianceSettingTierRiskLevel3_{{ trade.key }}_{{
                          trade.value.riskLevel3.complianceSettingId
                        }}"
                        class="form-check-label"
                        >Risk Level 3</label
                      >
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
</app-display-card>
